// ALL PAGES ADMIN DESIGN - v2025.01.01.1:30 PM
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import './index.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#FFFFFF',
            color: '#0C1C2B',
            borderRadius: '12px',
            border: '1px solid #E0E0E0',
            fontSize: '14px',
            maxWidth: '90vw',
          },
          success: {
            iconTheme: {
              primary: '#3DD598',
              secondary: '#FFFFFF',
            },
          },
          error: {
            iconTheme: {
              primary: '#F44336',
              secondary: '#FFFFFF',
            },
          },
        }}
      />
    </BrowserRouter>
  </StrictMode>,
) 